import React from 'react';
import { connect } from 'react-redux'
import * as actions from '../store/actions'
import ClubsList from './ClubsList'
import Spinner from './common/Spinner'

class App extends React.Component {
  componentWillMount() {
    this.props.loadUserInfo(window.location.search);    
  }
  renderContent() {
    const { dataStatus } = this.props;
    if(dataStatus !== 'loaded') {
      return <Spinner />
    }
    return <ClubsList />  
  }
  render() {
    return (
      <main>{ this.renderContent() }</main>
    )
  }
}

const stateToProps = state => ({
  dataStatus: state.dataStatus
});

export default connect(stateToProps, actions)(App);



// WEBPACK FOOTER //
// ./src/components/App.js